import { Component, OnInit } from "@angular/core";
import { RoleLevel, ApplicationRouteURL } from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { CustomerService } from "../../customer/models/customer.service";
import { InstanceService } from "../../instance/models/instance.service";
import { CompanyService } from "../../company/models/company.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { VehicleService } from "../../vehicle/models/vehicle.service";
import { CostCenterReportFilter } from "../models/report-filter-cost-center.model";
import { CostCenterReportService } from "../models/cost-center-report.service";
import { CostCenterReportResult } from "../models/cost-center-report.model";

@Component({
  selector: "wego-cost-center-report",
  template: require('../views/cost-center-report.component.html'),
  providers: [
    CustomerService,
    InstanceService,
    CompanyService,
    OrganizationService,
    VehicleService,
    CostCenterReportService
  ]
})
export class CostCenterReportComponent implements OnInit {
  currencySymbol: any;
  constructor(
    private authService: AuthService,
    private customerService: CustomerService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private organizationService: OrganizationService,
    private vehicleService: VehicleService,
    private costCenterReportService: CostCenterReportService
  ) {}

  isValidSearch: boolean = false;
  urlDefaultPage: string;
  reportName: string;
  roleLevel = RoleLevel;
  isLoading: boolean;
  isExport: boolean = false;
  errorModel: any;
  errorMessage: string;
  costCenterReportResult: CostCenterReportResult[];
  reportFilterModel: CostCenterReportFilter = new CostCenterReportFilter();

  ngOnInit() {
    this.reportName = "Cost_Center_Report";
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
  }

  public ResetValidSearch($event: any) {
    let isValidSearch: boolean = $event.isValidSearch;
    this.isValidSearch = isValidSearch;
    this.costCenterReportResult = [];
  }

  public OnSearch($event: any) {
    this.isLoading = true;
    this.reportFilterModel = $event.model;
    this.costCenterReportService
      .GetCostCenterReportData(this.reportFilterModel)
      .subscribe(
        res => {
          this.errorModel = [];
          if (!res.data) {
            this.isValidSearch = false;
            this.errorModel = res.error;
          } else {
            this.costCenterReportResult = res.data;            
            this.isValidSearch = res.data.length > 0 ? true : false;

            if (this.isValidSearch)
            {
              this.currencySymbol =  this.costCenterReportResult[0].currencySymbol;
            }

            if (typeof res.error === "string") {
              this.errorMessage = res.error;
            } else {
              this.errorModel = res.error;
            }
          }
          this.isLoading = false;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnExportExcel($event: any) {
    this.isLoading = true;
    this.reportFilterModel = $event.model;
    this.costCenterReportService
      .ExportCostCenterReportExcel(this.reportFilterModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName =
              "CostCenterReport" + new Date().toISOString() + ".xlsx";
            this.authService.DownloadXlsFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnExportPDF($event: any) {
    this.isLoading = true;
    this.reportFilterModel = $event.model;
    this.costCenterReportService.ExportCostCenterReportPdf(this.reportFilterModel).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "CostCenterReport" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public isDisplayColumn(columnName: string): Boolean {
    if (
      this.reportFilterModel.costTypeHashIdList.length == 0 ||
      this.reportFilterModel.costTypeHashIdList.indexOf(columnName) > -1
    ) {
      return true;
    } else return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/cost-center-report.component.ts